const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/Tag.tsx';
import { useTheme } from '@mui/material/styles';
import { css, cx } from '@emotion/css';
import { forwardRef, ReactNode, useMemo } from 'react';

interface Props {
    children: ReactNode;
    className?: string;
    color?: string;
    backgroundColor?: string;
}

function useCSSClasses(props: Props) {
    const theme = useTheme();
    return useMemo(
        () => ({
            // little workaround to get the dialog to have a fixed distance from top and bottom
            className: css`
                display: inline-block;
                background-color: ${props.backgroundColor ?? 'transparent'};
                color: ${props.color ?? 'inherit'};
                height: 20px;
                border-radius: 2px;
                padding: 0 4px;
                line-height: 20px;
                overflow: hidden;

                > * {
                    vertical-align: middle;
                }

                > *:not(:first-child) {
                    margin-left: 4px;
                }
            `,
        }),
        [theme, props.color, props.backgroundColor]
    );
}

export const Tag = forwardRef((props: Props, ref) => {
    const classes = useCSSClasses(props);
    return <div className={cx(classes.className, props.className)}>{props.children}</div>;
});

Tag.displayName = 'Tag';
